import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LoginResponse } from '../Redux/reducer/LoginReducer';
import Cookies from 'js-cookie';
import { useLogoutApiMutation } from '../Redux/Api/Contractor';
import { useEffect } from 'react';
import { api } from '../Redux/Api/rtkAPI';
// Import your API slice here

const useLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [LogoutCall, { data: logoutData, isError }] = useLogoutApiMutation();

    useEffect(() => {
        if (logoutData && logoutData?.success) {
            localStorage.removeItem('jwt');
            Cookies.remove('jwt');

            dispatch(LoginResponse(null));
            // dispatch(api.util.invalidateTags(["Contractor", "NavCount"]));

            // navigate('/signup');
        }

        if (isError) {
            console.error("Logout failed");
        }
    }, [logoutData, isError, dispatch, navigate]);

    // Pehle ye sab us useEffect me hota tha jo reload ke saath race karta tha —
    // aur reload aksar jeet jaata tha, yaani "logout" ke baad bhi jwt
    // localStorage me pada rehta tha aur rtkAPI use bhejta rehta tha. Ab sab
    // kuch reload se pehle, yahin.
    const clearLocalSession = () => {
        try {
            localStorage.removeItem('jwt');
            // Cart aur saved address bhi is user ka PII hai — shared/kiosk
            // device par agla banda inhe dekh leta tha.
            localStorage.removeItem('ci_cart_v1');
            localStorage.removeItem('ci_addresses_v1');
        } catch {
            /* storage blocked */
        }
        Cookies.remove('jwt');
        dispatch(LoginResponse(null));
    };

    const handleLogout = async () => {
        try {
            await LogoutCall().unwrap().then(() => {
                document.cookie.split(";").forEach((cookie) => {
                    const name = cookie.split("=")[0].trim();
                    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                });
            }).then(() => {
                clearLocalSession();
                document.location.reload()
            })

            // if (result.success) {
            //     localStorage.removeItem('jwt');
            //     Cookies.remove('jwt');

            //     dispatch(LoginResponse(null));
            //     dispatch(api.util.invalidateTags(["Contractor", "NavCount"]));

            //     navigate('/signup');
            // }
        } catch (error) {
            console.error("Logout failed:", error);
            // Server call fail bhi ho jaaye to local session to jaana hi
            // chahiye — warna user ko lagta hai wo logged out hai par nahi hai.
            clearLocalSession();
            document.location.reload();
        }
    };

    return { handleLogout };
};

export default useLogout;
